var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpFetchHandler } from './HttpFetchHandler';
import { HttpHandlerWithInterceptors } from './HttpInterceptor';
import { HttpRequest } from './HttpRequest';
import { HttpResponseNormalizerNoop } from './normalizers/HttpResponseNormalizerNoop';
var HttpClient = /** @class */ (function () {
    function HttpClient(config) {
        this.baseUrl = config.baseUrl;
        // Default handler is configured without interceptors
        this.requestHandler = this.createRequestHandler([]);
        // Default response normalizer passes through response JSON as is
        this.responseNormalizer = new HttpResponseNormalizerNoop();
    }
    HttpClient.prototype.createRequestHandler = function (interceptors) {
        return new HttpHandlerWithInterceptors(new HttpFetchHandler(), interceptors);
    };
    HttpClient.prototype.useInterceptors = function (interceptors) {
        this.requestHandler = this.createRequestHandler(interceptors);
    };
    HttpClient.prototype.useNormalizer = function (normalizer) {
        this.responseNormalizer = normalizer;
    };
    HttpClient.prototype.createRequest = function (request, opts) {
        return new HttpRequest(this.baseUrl, request, opts);
    };
    HttpClient.prototype.sendRequest = function (request, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var rawResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequestRaw(request, opts)];
                    case 1:
                        rawResponse = _a.sent();
                        return [2 /*return*/, rawResponse.body];
                }
            });
        });
    };
    /**
     * One may ask a question - Why do we normalize a raw response, that answer is actually
     * pretty straightforward
     *
     * Reason number 1 - if sendRequest() is normalized and sendRequestRaw() is not normalized
     * then one should apply normalizer on top of sendRequestRaw().body in order to actually consume
     * response data. Unfortunately, consumers are not all aware of the normalization implementation.
     *
     * Reason number 2 - Removing normalization can be added through opts object if there is really need for that.
     * The more expected behaviour is with normalization, in case we would remove normalization by default
     * passing opts: { normalize: true } to every request would be backwards breaking change,
     *
     * however, the situation where we remove normalization from some of the requests, that is not a backwards
     * breaking change.
     *
     * Reason number 3 - Bolt server raw response can still throw validation error, it needs to be handled.
     * In case we remove normalization, you will need to handle validation errors manually.
     */
    HttpClient.prototype.sendRequestRaw = function (request, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var req, resJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = this.createRequest(request, opts);
                        return [4 /*yield*/, this.requestHandler.handle(req)];
                    case 1:
                        resJson = _a.sent();
                        return [2 /*return*/, this.responseNormalizer.normalize(resJson, req)];
                }
            });
        });
    };
    return HttpClient;
}());
export { HttpClient };
